import { useContext } from "react"
import { AtribuirFaixasDistanciaContext } from "./AtribuirFaixasDistanciaContext"

export function useAtribuirFaixasDistanciaContext() {
    return useContext(AtribuirFaixasDistanciaContext)
}
